var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 60,
    viewBox: "0 0 203 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.916 60H7.49677C3.29858 60 0 56.7 0 52.5V7.5C0 3.3 3.29858 0 7.49677 0H194.916C199.114 0 202.413 3.3 202.413 7.5V52.5C202.413 56.7 199.114 60 194.916 60Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.916 1.2C198.365 1.2 201.213 4.05 201.213 7.5V52.5C201.213 55.95 198.365 58.8 194.916 58.8H7.49677C4.04826 58.8 1.19948 55.95 1.19948 52.5V7.5C1.19948 4.05 4.04826 1.2 7.49677 1.2H194.916ZM194.916 0H7.49677C3.29858 0 0 3.45 0 7.5V52.5C0 56.7 3.29858 60 7.49677 60H194.916C199.114 60 202.413 56.7 202.413 52.5V7.5C202.413 3.45 199.114 0 194.916 0Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0694 15.3C71.0694 16.5 70.7695 17.55 70.0198 18.3C69.1202 19.2 68.0707 19.65 66.7212 19.65C65.3718 19.65 64.3223 19.2 63.4227 18.3C62.523 17.4 62.0732 16.35 62.0732 15C62.0732 13.65 62.523 12.6 63.4227 11.7C64.3223 10.8 65.3718 10.35 66.7212 10.35C67.321 10.35 67.9207 10.5 68.5205 10.8C69.1202 11.1 69.57 11.4 69.8699 11.85L69.1202 12.6C68.5205 11.85 67.7708 11.55 66.7212 11.55C65.8216 11.55 64.922 11.85 64.3223 12.6C63.5726 13.2 63.2727 14.1 63.2727 15.15C63.2727 16.2 63.5726 17.1 64.3223 17.7C65.072 18.3 65.8216 18.75 66.7212 18.75C67.7708 18.75 68.5205 18.45 69.2701 17.7C69.7199 17.25 70.0198 16.65 70.0198 15.9H66.7212V14.7H71.0694V15.3ZM77.9664 11.55H73.9181V14.4H77.6665V15.45H73.9181V18.3H77.9664V19.5H72.7187V10.5H77.9664V11.55ZM82.9143 19.5H81.7148V11.55H79.1659V10.5H85.4632V11.55H82.9143V19.5ZM89.8113 19.5V10.5H91.0108V19.5H89.8113ZM96.1086 19.5H94.9091V11.55H92.3602V10.5H98.5075V11.55H95.9586V19.5H96.1086ZM110.352 18.3C109.453 19.2 108.403 19.65 107.054 19.65C105.704 19.65 104.655 19.2 103.755 18.3C102.856 17.4 102.406 16.35 102.406 15C102.406 13.65 102.856 12.6 103.755 11.7C104.655 10.8 105.704 10.35 107.054 10.35C108.403 10.35 109.453 10.8 110.352 11.7C111.252 12.6 111.702 13.65 111.702 15C111.702 16.35 111.252 17.4 110.352 18.3ZM104.655 17.55C105.255 18.15 106.154 18.6 107.054 18.6C107.953 18.6 108.853 18.3 109.453 17.55C110.053 16.95 110.502 16.05 110.502 15C110.502 13.95 110.203 13.05 109.453 12.45C108.853 11.85 107.953 11.4 107.054 11.4C106.154 11.4 105.255 11.7 104.655 12.45C104.055 13.05 103.605 13.95 103.605 15C103.605 16.05 103.905 16.95 104.655 17.55ZM113.351 19.5V10.5H114.701L119.049 17.55V10.5H120.248V19.5H119.049L114.401 12.15V19.5H113.351Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.106 32.7C98.5076 32.7 95.6589 35.4 95.6589 39.15C95.6589 42.75 98.5076 45.6 102.106 45.6C105.705 45.6 108.553 42.9 108.553 39.15C108.553 35.25 105.705 32.7 102.106 32.7ZM102.106 42.9C100.157 42.9 98.5076 41.25 98.5076 39C98.5076 36.75 100.157 35.1 102.106 35.1C104.055 35.1 105.705 36.6 105.705 39C105.705 41.25 104.055 42.9 102.106 42.9ZM88.1621 32.7C84.5637 32.7 81.7149 35.4 81.7149 39.15C81.7149 42.75 84.5637 45.6 88.1621 45.6C91.7606 45.6 94.6093 42.9 94.6093 39.15C94.6093 35.25 91.7606 32.7 88.1621 32.7ZM88.1621 42.9C86.2129 42.9 84.5637 41.25 84.5637 39C84.5637 36.75 86.2129 35.1 88.1621 35.1C90.1113 35.1 91.7606 36.6 91.7606 39C91.7606 41.25 90.1113 42.9 88.1621 42.9ZM71.5193 34.65V37.35H77.9665C77.8166 38.85 77.2168 40.05 76.4671 40.8C75.5675 41.7 74.0682 42.75 71.5193 42.75C67.471 42.75 64.4723 39.6 64.4723 35.55C64.4723 31.5 67.621 28.35 71.5193 28.35C73.6184 28.35 75.2677 29.25 76.4671 30.3L78.4163 28.35C76.767 26.85 74.6679 25.65 71.6692 25.65C66.2715 25.65 61.6235 30.15 61.6235 35.55C61.6235 40.95 66.2715 45.45 71.6692 45.45C74.6679 45.45 76.767 44.55 78.5662 42.6C80.3655 40.8 80.9652 38.25 80.9652 36.3C80.9652 35.7 80.9652 35.1 80.8153 34.65H71.5193ZM139.59 36.75C138.99 35.25 137.491 32.7 134.192 32.7C130.894 32.7 128.195 35.25 128.195 39.15C128.195 42.75 130.894 45.6 134.492 45.6C137.341 45.6 139.14 43.8 139.74 42.75L137.641 41.25C136.891 42.3 135.992 43.05 134.492 43.05C132.993 43.05 132.093 42.45 131.343 41.1L139.89 37.5L139.59 36.75ZM130.894 38.85C130.894 36.45 132.843 35.1 134.192 35.1C135.242 35.1 136.291 35.7 136.591 36.45L130.894 38.85ZM123.847 45H126.696V26.25H123.847V45ZM119.349 34.05C118.599 33.3 117.4 32.55 115.9 32.55C112.752 32.55 109.753 35.4 109.753 39C109.753 42.6 112.602 45.3 115.9 45.3C117.4 45.3 118.599 44.55 119.199 43.8H119.349V44.7C119.349 47.1 117.999 48.45 115.9 48.45C114.251 48.45 113.051 47.25 112.752 46.2L110.353 47.25C111.102 48.9 112.901 51 116.05 51C119.349 51 122.048 49.05 122.048 44.4V33H119.349V34.05ZM116.05 42.9C114.101 42.9 112.452 41.25 112.452 39C112.452 36.75 114.101 35.1 116.05 35.1C117.999 35.1 119.499 36.75 119.499 39C119.499 41.25 117.999 42.9 116.05 42.9ZM152.634 26.25H145.887V45H148.736V37.95H152.634C155.783 37.95 158.782 35.7 158.782 32.1C158.782 28.5 155.783 26.25 152.634 26.25ZM152.784 35.25H148.736V28.8H152.784C154.883 28.8 156.083 30.6 156.083 31.95C155.933 33.6 154.733 35.25 152.784 35.25ZM170.027 32.55C167.928 32.55 165.829 33.45 165.079 35.4L167.628 36.45C168.228 35.4 169.127 35.1 170.177 35.1C171.676 35.1 173.026 36 173.175 37.5V37.65C172.726 37.35 171.526 36.9 170.327 36.9C167.628 36.9 164.929 38.4 164.929 41.1C164.929 43.65 167.178 45.3 169.577 45.3C171.526 45.3 172.426 44.4 173.175 43.5H173.325V45H176.024V37.8C175.724 34.5 173.175 32.55 170.027 32.55ZM169.727 42.9C168.827 42.9 167.478 42.45 167.478 41.25C167.478 39.75 169.127 39.3 170.477 39.3C171.676 39.3 172.276 39.6 173.026 39.9C172.726 41.7 171.226 42.9 169.727 42.9ZM185.47 33L182.322 41.1H182.172L178.873 33H175.874L180.822 44.4L177.973 50.7H180.822L188.469 33H185.47ZM160.281 45H163.13V26.25H160.281V45Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5934 11.2498C15.1436 11.6998 14.9937 12.4498 14.9937 13.3498V46.4998C14.9937 47.3998 15.2935 48.1498 15.7433 48.5998L15.8933 48.7498L34.4853 30.1498V29.8498L15.5934 11.2498Z",
    fill: "url(#paint0_linear_3_90)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4826 36.45L34.3352 30.3V29.85L40.4826 23.7L40.6325 23.85L47.9793 28.05C50.0784 29.25 50.0784 31.2 47.9793 32.4L40.4826 36.45Z",
    fill: "url(#paint1_linear_3_90)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6325 36.3L34.3352 30L15.5933 48.75C16.3429 49.5 17.3925 49.5 18.7419 48.9L40.6325 36.3Z",
    fill: "url(#paint2_linear_3_90)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6325 23.7L18.7419 11.25C17.3925 10.5 16.3429 10.65 15.5933 11.4L34.3352 30L40.6325 23.7Z",
    fill: "url(#paint3_linear_3_90)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.4825 36.15L18.7419 48.45C17.5424 49.2 16.4929 49.05 15.7432 48.45L15.5933 48.6L15.7432 48.75C16.4929 49.35 17.5424 49.5 18.7419 48.75L40.4825 36.15Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M15.5934 48.45C15.1436 48 14.9937 47.25 14.9937 46.35V46.5C14.9937 47.4 15.2935 48.15 15.7433 48.6V48.45H15.5934ZM47.9794 31.95L40.4827 36.15L40.6326 36.3L47.9794 32.1C49.029 31.5 49.4788 30.75 49.4788 30C49.4788 30.75 48.8791 31.35 47.9794 31.95Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M18.742 11.4L47.9794 28.05C48.8791 28.65 49.4788 29.25 49.4788 30C49.4788 29.25 49.029 28.5 47.9794 27.9L18.742 11.25C16.6429 10.05 14.9937 10.95 14.9937 13.35V13.5C14.9937 11.25 16.6429 10.2 18.742 11.4Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_90",
    x1: 32.686,
    y1: 13.0648,
    x2: 7.51153,
    y2: 38.2269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_90",
    x1: 50.7291,
    y1: 30.0015,
    x2: 14.4493,
    y2: 30.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_90",
    x1: 37.2244,
    y1: 33.444,
    x2: 3.08745,
    y2: 67.5663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_90",
    x1: 10.9408,
    y1: 0.263985,
    x2: 26.1853,
    y2: 15.5019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.295c4887673d03cf21c4569633157551.svg";
export { ForwardRef as ReactComponent };